import { ButtonMui } from 'src/components/ButtonMui'
import styled from 'styled-components'

export const Wrapper = styled.div.attrs(() => ({
  className: 'table-responsive mt-4',
}))`
  overflow-y: auto;
  height: 550px;
`

export const CustomButton = styled(ButtonMui)`
  width: 5rem;
`
